import { Box, BoxProps } from '@mui/material';
import type { ElementType } from 'react';

import LinkUnstyled from 'components/@common/LinkUnstyled';

const Card = <T extends ElementType = typeof LinkUnstyled | 'div'>({
  children,
  component,
  sx,
  ...rest
}: BoxProps<T>) => {
  return (
    <Box
      component={component}
      sx={[
        {
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          zIndex: 1,
          flexDirection: 'column',
          borderRadius: 4,
          flex: '1 auto',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Card;
